/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const createMemoRequestDtoSchema = z.object({
    "body": z.string().describe("Free-text note body."),
"occurredAt": z.optional(z.iso.datetime().describe("Business time when the note was recorded. Defaults to now."))
    })